<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <NotesListSearch @on-search="onSearch"></NotesListSearch>
    </div>

    <div class="table-wrap">
      <Table
        :columns="columns"
        :data="tableList"
        border
        :loading="loading"
        :max-height="tableHeight"
      >
        <template slot="orgId" slot-scope="{ row, index }">
          {{ row.orgId || '--' }}
        </template>
        <template slot="orgName" slot-scope="{ row, index }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>
        <template slot="acctNo" slot-scope="{ row, index }">
          {{ row.acctNo || '--' }}
        </template>
        <template slot="acctName" slot-scope="{ row, index }">
          <div v-if="row.acctName">
            <TablePoptip :content="row.acctName"> </TablePoptip>
          </div>
          <span v-else>--</span>
        </template>
        <template slot="configName" slot-scope="{ row, index }">
          <TablePoptip :content="row.configName"> </TablePoptip>
        </template>

        <template slot="inAcctType" slot-scope="{ row, index }">
          {{ inAcctTypeObj[row.inAcctType] || '-' }}
        </template>
        <template slot="enable" slot-scope="{ row, index }">
          <span v-if="row.enable == 1" style="color: #19be6b">开启</span>
          <span v-else style="#c5c8ce">已关闭</span>
        </template>
        <template slot="accountingType" slot-scope="{ row, index }">
          <span v-if="row.accountingType == 1">按月考勤节次</span>
          <span v-if="row.accountingType == 2">按固定时长</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :current="pageInfo.pageNum"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pageSizeOpts"
        @on-change="pageChange"
        @on-page-size-change="handleSizeChange"
      ></Page>
    </div>
  </div>
</template>

<script>
import NotesListSearch from './assets/components/NotesListSearch.vue';
import { columns } from './assets/data/notesList';
import orderCenterApi from '@/request/orderCenter/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { mapMutations } from 'vuex';

export default {
  name: 'OrderCenterProfitSharingNotesList',
  components: {
    NotesListSearch
  },

  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('OrderCenterProfitSharingNotesList');
    next();
  },
  data() {
    return {
      columns,
      tableList: [],
      pageSizeOpts: [10, 20, 50, 100],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      inAcctTypeObj: {
        1: '平安银行',
        2: '花都工行',
        3: '微信线下'
      } // inAcctType  入账类型 1-平安 2-花都工行 3-微信线下

    };
  },
  created() {
    this.getDivideConfigConfigRelPage();
  },
  activated() {
    this.getDivideConfigConfigRelPage();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    // 列表数据
    async getDivideConfigConfigRelPage(info) {
      const parameter = {
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        ...info
      };
      this.loading = true;
      const res = await orderCenterApi.getDivideConfigConfigRelPage(parameter);
      this.loading = false;
      if (res.data.status == 200) {
        this.tableList = res.data.message.list;
        this.pageInfo.total = Number(res.data.message.total);
      }
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getDivideConfigConfigRelPage();
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getDivideConfigConfigRelPage();
    },
    onSearch(info) {
      this.pageInfo.pageNum = 1;
      this.getDivideConfigConfigRelPage(info);
    }

  }
};
</script>

<style lang="scss" scoped>
.table-wrap {
  padding-top: 16px;
}
</style>
